import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pulse-filters" }
const _hoisted_2 = { class: "inputs" }
const _hoisted_3 = { class: "buttons" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FeedSearch = _resolveComponent("FeedSearch")
  const _component_FeedCalendar = _resolveComponent("FeedCalendar")
  const _component_PulseEntities = _resolveComponent("PulseEntities")
  const _component_IconFav = _resolveComponent("IconFav")
  const _component_PulseButton = _resolveComponent("PulseButton")
  const _component_PulseTooltip = _resolveComponent("PulseTooltip")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FeedSearch, {
        modelValue: _ctx.value.search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value.search) = $event)),
        loading: $props.loading
      }, null, 8 /* PROPS */, ["modelValue", "loading"]),
      _createVNode(_component_FeedCalendar, {
        ref: "date",
        modelValue: _ctx.value.date,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.value.date) = $event)),
        class: "calendar"
      }, null, 8 /* PROPS */, ["modelValue"]),
      _createVNode(_component_PulseEntities, {
        ref: "entities",
        class: "entities",
        onApply: _cache[2] || (_cache[2] = $event => (_ctx.value.entities = $event))
      }, null, 512 /* NEED_PATCH */),
      ($props.hasFilters)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "clear pointer",
            onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit('clear')))
          }, " Clear filters "))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(["saved pointer", {active: _ctx.value.favorite}]),
        onClick: _cache[4] || (_cache[4] = $event => (_ctx.value.favorite = !_ctx.value.favorite))
      }, [
        _createVNode(_component_IconFav, {
          size: "1.6rem",
          favorite: _ctx.value.favorite
        }, null, 8 /* PROPS */, ["favorite"]),
        _cache[6] || (_cache[6] = _createTextVNode(" Saved "))
      ], 2 /* CLASS */)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_PulseTooltip, {
        title: "All signals",
        content: "A complete view of every signal across all categories."
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PulseButton, {
            active: !$options.active_filter,
            class: "filter-btn",
            text: "All",
            count: $props.allCount,
            onClick: _cache[5] || (_cache[5] = $event => (_ctx.value.category = undefined))
          }, null, 8 /* PROPS */, ["active", "count"])
        ]),
        _: 1 /* STABLE */
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.CATEGORIES, (item) => {
        return (_openBlock(), _createBlock(_component_PulseTooltip, {
          key: item.type,
          title: item.title,
          content: item.content
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PulseButton, {
              class: "filter-btn",
              disabled: $props.semanticSearch,
              active: item.type === $options.active_filter,
              color: item.color,
              icon: item.icon,
              text: _ctx.$utils.str.capitalize(item.type),
              count: $props.semanticSearch ? '?' : ($props.categoriesCount?.[item.type] || 0),
              onClick: $event => (_ctx.value.category = _ctx.value.category === item.type ? undefined : item.type)
            }, null, 8 /* PROPS */, ["disabled", "active", "color", "icon", "text", "count", "onClick"])
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "content"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}